import React from 'react';
import { Users, TrendingUp, Shield, Trophy } from 'lucide-react';
export function FooterPillBar() {
  const pillars = [{
    icon: Users,
    title: 'Develop People',
    desc: 'Invest in others. Build leaders.'
  }, {
    icon: TrendingUp,
    title: 'Drive Production',
    desc: 'Consistent systems. Consistent results.'
  }, {
    icon: Shield,
    title: 'Lead with Purpose',
    desc: 'Set the standard. Be the example.'
  }, {
    icon: Trophy,
    title: 'Earn More',
    desc: 'More units. More impact. More income.'
  }];
  return <div className="mt-8" data-id="element-100">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-101">
        {pillars.map((pillar, idx) => <div key={idx} className="bg-white rounded-xl border border-slate-200 p-4 flex items-center gap-4 shadow-sm hover:shadow-md transition-shadow" data-id="element-102">
            <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center text-blue-600 shrink-0" data-id="element-103">
              <pillar.icon size={20} data-id="element-104" />
            </div>
            <div data-id="element-105">
              <h4 className="text-sm font-bold text-[#0a1e5e] uppercase tracking-wide" data-id="element-106">
                {pillar.title}
              </h4>
              <p className="text-xs text-slate-500 mt-0.5" data-id="element-107">{pillar.desc}</p>
            </div>
          </div>)}
      </div>

      <div className="flex justify-center" data-id="element-108">
        <div className="bg-slate-100/70 rounded-lg px-6 py-3 max-w-2xl" data-id="element-109">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center" data-id="element-110">
            Compensation structures, requirements, and policies are subject to
            change at any time.
          </p>
        </div>
      </div>
    </div>;
}